var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoDeposits40X40 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 30,
    viewBox: "0 0 27 30",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27689",
    "data-name": "Group 27689",
    transform: "translate(-222.27 -629.987)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27682",
    "data-name": "Group 27682",
    transform: "translate(247.57 652.354)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27681",
    "data-name": "Group 27681"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47334",
    "data-name": "Path 47334",
    d: "M248.369,653.4a4.621,4.621,0,0,1-.7.7v3.834h.4a1.324,1.324,0,0,0,1.3-1.3V652.2Z",
    transform: "translate(-247.669 -652.198)",
    fill: "#74276b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27751",
    "data-name": "Group 27751",
    transform: "translate(224.27 629.987)",
    fill: "#74276b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47419",
    "data-name": "Path 47419",
    d: "M244.877,642.169H223.664a1.344,1.344,0,0,0-1.394,1.3v14.963a1.5,1.5,0,0,0,1.394,1.4h21.214a1.364,1.364,0,0,0,1.394-1.4v-4.073h-3.982a3.642,3.642,0,0,1-3.584-3.6,3.557,3.557,0,0,1,3.584-3.5h3.982v-3.79A1.344,1.344,0,0,0,244.877,642.169Z",
    transform: "translate(-224.27 -629.832)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47420",
    "data-name": "Path 47420",
    d: "M237.082,641.563V641.3a2.4,2.4,0,0,1-2.3-2.41l1.377-.115a1.423,1.423,0,0,0,1.492,1.377c.689,0,1.377-.229,1.377-1.033s-1.148-.918-1.606-1.033c-1.148-.344-2.3-.918-2.3-2.18a2.036,2.036,0,0,1,1.951-2.065v-.8h1.147v.8a2.343,2.343,0,0,1,2.181,2.18h-1.492c-.114-.8-.458-1.033-1.262-1.033-.344,0-1.148.115-1.148.8s1.033.8,1.492.918c1.377.344,2.525.8,2.525,2.41a2.207,2.207,0,0,1-2.3,2.181v.261h5.517a7.187,7.187,0,0,0,1.168-3.919V637.5a7.384,7.384,0,0,0-7.4-7.116,7.237,7.237,0,0,0-5.949,11.178Z",
    transform: "translate(-224.652 -630.385)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47421",
    "data-name": "Path 47421",
    d: "M230.17,641.159c-.1-.2-.2-.5-.3-.7h-3.3a1.525,1.525,0,0,0-1.2.7Z",
    transform: "translate(-224.27 -629.931)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47422",
    "data-name": "Path 47422",
    d: "M247.97,640.459h-3.2c-.1.2-.2.5-.3.7h.5a2.647,2.647,0,0,1,2.6,2.6v3.3l1.7-2.2v-3.1A1.324,1.324,0,0,0,247.97,640.459Z",
    transform: "translate(-224.369 -629.917)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27688",
    "data-name": "Group 27688",
    transform: "translate(239.916 646.296)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27687",
    "data-name": "Group 27687"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47337",
    "data-name": "Path 47337",
    d: "M249.215,646.425l-1,1.3a2.445,2.445,0,0,1-1.1.9,2.768,2.768,0,0,1-1.3.3h-3.6a2.357,2.357,0,0,0,.1,4.708h3.6a1.457,1.457,0,0,0,1.3-.7l2-2.6Zm-5.4,5.508h-1.5a.652.652,0,1,1-.1-1.3h1.6a.669.669,0,0,1,.6.7A.645.645,0,0,1,243.815,651.933Z",
    transform: "translate(-240.015 -646.425)",
    fill: "#74276b"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoDeposits40X40);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_deposits40x40.2ff38ea54d0b405c8aff49afdb4f671b.svg";